"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.collaborators = void 0;
const actions = __importStar(require("../../../../../shared/store/action_constants"));
function activeCollaborator(state, { payload }) {
    if (state.find(user => user.socketId === payload.socketId)) {
        console.warn('! ' + 'warning user enter with same socketid');
        return state;
    }
    return [...state, payload];
}
function deactivateCollaborator(state, { payload }) {
    return state.filter(user => user.socketId !== payload.socketId);
}
function userCursorMove(state, { payload }) {
    const { socketId } = payload, rest = __rest(payload, ["socketId"]);
    return state.map(user => {
        if (user.socketId === socketId) {
            return Object.assign(Object.assign({}, user), { activeCell: rest });
        }
        return user;
    });
}
const collaborators = (state = [], action) => {
    switch (action.type) {
        case actions.DATASHEET_ACTIVE_COLLABORATOR: {
            return activeCollaborator(state, action);
        }
        case actions.DATASHEET_DEACTIVATE_COLLABORATOR: {
            return deactivateCollaborator(state, action);
        }
        case actions.DATASHEET_ROOM_INFO_SYNC: {
            return action.payload;
        }
        case actions.CURSOR_MOVE: {
            return userCursorMove(state, action);
        }
        default:
            return state;
    }
};
exports.collaborators = collaborators;
//# sourceMappingURL=collaborators.js.map